import moment from 'moment';

const parseFormatString = (pattern: string) => {
  //formatting tokens for moment.js - defined in `moment().format()`
  //https://github.com/moment/moment/blob/develop/src/lib/format/format.js
  const formattingTokens =
    /(\[[^[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
  const localFormattingTokens = /(\[[^[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

  //The only local format that includes seconds is the `LTS` format. Once we've checked for that,
  //strip out local tokens so that they don't interfere with parsing normal formatting tokens
  //(specifically the 'S' since that is normally "fractional seconds").
  const hasLocalSeconds = pattern.match(localFormattingTokens)?.some((t) => /^LTS$/.test(t)) ?? false;
  pattern = pattern.replace(localFormattingTokens, '');

  const tokens = pattern.match(formattingTokens);
  const secondsRequired = tokens?.some((t) => /^([Hh]mmss)|(ss?)$/.test(t)) ?? false;
  //number of digits = number of consecutive `S` characters in the pattern
  const fractionalSecondsDigits = tokens?.find((t) => /^S{1,9}$/.test(t))?.length ?? 0;
  return {
    includesSeconds: hasLocalSeconds || secondsRequired || fractionalSecondsDigits > 0,
    fractionalSecondsDigits,
  };
};

export const getTimeInputDataForPattern = (pattern: string) => {
  const options = parseFormatString(pattern);
  return {
    includeSeconds: options.includesSeconds,
    includeFractionalSeconds: options.fractionalSecondsDigits > 0,
    fractionalSecondDigits: options.fractionalSecondsDigits,
    html5TimePattern: options.includesSeconds
      ? options.fractionalSecondsDigits > 0
        ? moment.HTML5_FMT.TIME_MS
        : moment.HTML5_FMT.TIME_SECONDS
      : moment.HTML5_FMT.TIME,
    html5DateTimeLocalPattern: options.includesSeconds
      ? options.fractionalSecondsDigits > 0
        ? moment.HTML5_FMT.DATETIME_LOCAL_MS
        : moment.HTML5_FMT.DATETIME_LOCAL_SECONDS
      : moment.HTML5_FMT.DATETIME_LOCAL,
    step: options.includesSeconds ? Math.pow(10, -options.fractionalSecondsDigits) : undefined,
  };
};
